import formAppHomeAPIUrls from './formAppHomeAPIUrls';
import formAppHomeConfigs from './formAppHomeConfigs';
import formAppHomeMain from './formAppHomeMain';
import formAppHomeSpaces from './formAppHomeSpaces';

import formMainHubCanvas from './formMainHubCanvas';
import formMainHubCanvasLegacy from './formMainHubCanvasLegacy';
import formSpacesMap from './formSpacesMap';

export default {
  title: 'White Label Pro App Home',
  attributeName: 'wlproHome',
  getURL: 'app/mainHubId/home/configId',
  updateURL: 'mainHub/mainHubId',
  // createURL: 'tags',
  // updateURL: 'appId/tags',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: false,
  sessionParams: ['mainHubId','configId'],
  formConfig: [formAppHomeMain, formMainHubCanvasLegacy, formSpacesMap,formAppHomeAPIUrls], //,formTagsPosterEdit,formTagsExtendedEdit,formAppHomeConfigs,formAppHomeSpaces],
  noArea: false,
  goBack: false,
  isMainHub:true,
  isSpaceMap:true
  // reconfirmMessage:'Are you sure you want to save this overwritten tag?',
};
